import { makeStyles } from '@material-ui/styles';
import cn from 'clsx';

const BaseButton: React.FC<JSX.IntrinsicElements['button']> = ({
    children,
    className,
    type = 'button',
    ...domProps
}) => {
    const classes = useStyles();
    return (
        <button className={cn(classes.root, className)} type={type} {...domProps}>
            {children}
        </button>
    );
};

const useStyles = makeStyles(
    {
        root: {
            border: 0,
            background: 'none',
            whiteSpace: 'nowrap',
            textDecoration: 'none',
            margin: 0,
            padding: 0,
            cursor: 'pointer',
            color: 'inherit',
            fontSize: 'inherit',
            fontWeight: 'inherit',
            fontFamily: 'inherit',
            userSelect: 'none',
            // -webkit-tap-highlight-color and outline:
            // on mobile, remove the blue background when tapping buttons
            '-webkit-tap-highlight-color': 'transparent',
            outline: 'none',
        },
    },
    { classNamePrefix: 'BaseButton' }
);

export default BaseButton;
